module.exports = __webpack_public_path__ + "static/media/marker-auto.13817f5c.svg";